define.alias("shared/components/shared/publish/index", "media/components/shared/publish/index");